import React from 'react';
import ReactDOM from 'react-dom';

import { ContentModal } from 'sma.common/components/modals';
import Loader from 'sma.admin/components/loader';

import Piper from './piper';
import getComponentWithTheme from '../../themeProvider';

const ajax = require('sma.common/ajax');

class PipingModal extends Backbone.View {
	initialize(options) {
		this.context = options.context || null;
		if (typeof this.context === 'string') {
			this.context = [this.context];
		}
		this.froala = options.froala || null;
		this.$textField = options.$textField || null;
		this.fromModal = options.fromModal || false;
		this.updateQueue = this.updateQueue.bind(this);
		this.award_id = options.award_id || window.sma_award_id || null;

		this.createModal();
	}

	createModal() {
		const modalContent = '<div id="sma-js-piping-container"><div class="mt-4 btn-loader"></div></div>';

		this.modal = new ContentModal(modalContent, {
			destroyOnClose: true,
			size: 'md',
			title: gettext('Add piping'),
			fromModal: this.fromModal,
			buttons: [{
				label: gettext('Cancel'),
				cls: 'btn btn-link btn-loud',
				handler: (modal) => {
					modal.hide();
				},
			}, {
				label: gettext('Add'),
				cls: 'btn btn-primary btn-loud',
				handler: (modal) => {
					this.submitQueue();
					modal.hide();
				},
			}],
		});

		this.setElement(this.modal.modalWindow);
		new Loader(this.modal.modalBody.find('.btn-loader')[0], 'md');
		this.loadData();
	}

	submitQueue() {
		const delimSelectElement = document.getElementById('sma-js-pipes-delim-selector');
		const delim = delimSelectElement ? delimSelectElement.value : null;

		if (this.froala) {
			this.froala.insertText(this.queue.map((variable) => {
				let { value } = variable;

				if (variable.isMulti && delim) {
					value = `${value}__${delim}`;
				}

				return {
					label: variable.label,
					group: variable.group,
					value,
				};
			}), this.$textField);
		} else {
			const existingContent = this.$textField.val();
			const tags = this.queue.map((variable) => {
				let { value } = variable;

				if (variable.isMulti && delim) {
					value = `${value}__${delim}`;
				}

				return `{{ ${value} }}`;
			}).join(' ');

			this.$textField.val(existingContent + tags);
		}
	}

	loadData() {
		this.modal.show();
		ajax.get({
			url: reverse('pipes-index'),
			data: {
				program_id: this.award_id,
				context: this.context,
			},
			callback: (data) => {
				this.injectReact(data.result);
			},
		});
	}

	updateQueue(newQueue) {
		this.queue = newQueue;
	}

	injectReact(data) {
		ReactDOM.render(
			getComponentWithTheme(
				<Piper
					data={data}
					updateQueue={this.updateQueue}
				/>,
				window.LOCALE.theme,
			),
			document.getElementById('sma-js-piping-container'),
		);
	}
}

// activate all piping text fields
$(() => {
	$('.sma-js-piping-text-button').each((i, item) => {
		const $pipingButton = $(item);

		const contextString = $pipingButton.attr('data-context');

		if (contextString) {
			var context = contextString.split(' ');
		} else {
			var context = null;
		}

		$pipingButton.on('click', function () {
			this.modal = new PipingModal({
				context,
				$textField: $pipingButton.parent().find('input'),
			});
		});
	});
});

module.exports = PipingModal;
